function AuthInterceptor($q, $cookies) {
  return {
    request: (config) => {
      const token = $cookies.get('token');
      config.headers = config.headers || {};
      if (token) {
        config.headers.Authorization = "Bearer " + token;
      }
      return config || $q.when(config);
    },
  }
}
AuthInterceptor.$inject = ['$q', '$cookies'];

export default function config($compileProvider, $httpProvider, $locationProvider, ENV, ngDialogProvider) {
  'ngInject';

  $locationProvider.html5Mode({enabled: false, requireBase: false}).hashPrefix('');
  $httpProvider.interceptors.push(AuthInterceptor);
  $compileProvider.debugInfoEnabled(ENV.debugInfoEnabled);
  ngDialogProvider.setDefaults({
    plain: true,
    showClose: true,
    closeByNavigation: true,
    closeByEscape: true,
  });
}



// WEBPACK FOOTER //
// ./src/app/app.config.js